import { PaymentFormValues } from '../model/payment.types'
import { getServiceFieldsConfig } from './getServiceFieldsConfig'

interface GetSbpQRPaymentParamsByTspUrlArgs {
  values: PaymentFormValues
  lastActivatedPromocode: string
  isVoucher: boolean
  isGameKey: boolean
  url: string
  fields: Array<{ name: string }>
}

export const getSbpQRPaymentParamsByTspUrl = ({
  values,
  isVoucher,
  isGameKey,
  url,
  lastActivatedPromocode,
  fields,
}: GetSbpQRPaymentParamsByTspUrlArgs) => {
  const {
    isUidOnlyService,
    isUidAndServerService,
    isUidAndServerAndRegionService,
    isIdAndZoneIdService,
    isIdAndServerService,
    isPlayerIdAndZoneIdService,
    isPlayerIdAndServerService,
    isPlayerIdOnlyService,
    isPubgService,
  } = getServiceFieldsConfig(fields)

  const promocode = lastActivatedPromocode ? { promoCode: lastActivatedPromocode } : {}

  if (isGameKey) {
    return {
      recipientInfo: {
        email: values?.email,
      },
    }
  }

  if (isVoucher) {
    if (isPubgService) {
      return {
        recipientInfo: {
          account: values?.uidPubg,
        },
        productInfo: {
          ...promocode,
        },
      }
    }
    if (isUidOnlyService) {
      return {
        recipientInfo: {
          account: values?.uid,
        },
      }
    }
    if (isUidAndServerService) {
      const isGenshin = url === 'genshin'
      const isHonkai = url === 'honkai-star-rail'
      const isZenless = url === 'zenless-zone-zero'
      const isIdentityV = url === 'identity-v'

      if (isGenshin || isHonkai || isZenless || isIdentityV) {
        return {
          recipientInfo: {
            account: values?.uid,
          },
          productInfo: {
            region: values?.server,
            ...(isGenshin ? promocode : {}),
          },
        }
      }

      return {
        recipientInfo: {
          account: `${values?.uid}:${values?.server}`,
        },
      }
    }
    if (isUidAndServerAndRegionService) {
      return {
        recipientInfo: {
          account: `${values?.uid}:${values?.region}`,
        },
        productInfo: {
          region: values?.server,
        },
      }
    }
    if (isIdAndZoneIdService) {
      return {
        recipientInfo: {
          account: `${values?.id}:${values?.zoneId}`,
        },
      }
    }
    if (isIdAndServerService) {
      return {
        recipientInfo: {
          account: `${values?.id}:${values?.server}`,
        },
      }
    }
    if (isPlayerIdAndServerService) {
      return {
        recipientInfo: {
          account: `${values?.id}:${values?.server}`,
        },
      }
    }
    if (isPlayerIdAndZoneIdService) {
      return {
        recipientInfo: {
          account: `${values?.id}:${values?.zoneId}`,
        },
      }
    }
    if (isPlayerIdOnlyService) {
      return {
        recipientInfo: {
          account: values?.playerId,
        },
      }
    }

    return {
      recipientInfo: {
        email: values?.email,
      },
    }
  }

  return {
    recipientInfo: {
      account: values?.login.trim(),
    },
    productInfo: {
      ...promocode,
    },
  }
}
